import React from 'react';

import type { SessionLockCopy } from '../types';

const DEFAULT_COPY: SessionLockCopy = {
  title: 'Session Expired',
  message: 'Your session is expired. Click Log out to close your session.',
  logoutLabel: 'Log out',
};

export interface SessionLockModalProps {
  copy?: SessionLockCopy;
  onLogout: () => void;
}

export const SessionLockModal: React.FC<SessionLockModalProps> = ({
  copy,
  onLogout,
}) => {
  const { title, message, logoutLabel } = copy ?? DEFAULT_COPY;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-lock-title"
      aria-describedby="session-lock-message"
      className="fixed inset-0 z-session-lock flex items-center justify-center bg-black bg-opacity-50"
    >
      <div className="w-11/12 max-w-md rounded bg-white p-8 shadow-session-lock">
        <h2
          id="session-lock-title"
          className="mb-4 text-xl font-bold text-gray-900"
        >
          {title}
        </h2>
        <p
          id="session-lock-message"
          role="alert"
          className="mb-6 text-sm leading-relaxed text-gray-600"
        >
          {message}
        </p>
        <button
          type="button"
          onClick={onLogout}
          className="inline-flex cursor-pointer items-center justify-center rounded bg-gray-900 px-6 py-2 text-sm font-semibold text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
        >
          {logoutLabel}
        </button>
      </div>
    </div>
  );
};
